import { eventNames } from '@react/tracking/services/algolia';
import { useCallback } from 'react';

export function useGetEventName(index, parentView, parentSubview) {
    return useCallback(() => {
        let eventName = 'Click Search Result';

        if (parentView === 'Connections') {
            eventName = parentSubview;
        } else if (parentView === 'Events') {
            if (index === 'members' || index === 'saved_searchable_members') {
                eventName = eventNames.EVENT_CONNECT;
            } else if (index === 'properties') {
                eventName = eventNames.EVENT_PROPERTIES;
            }
        } else if (parentView === 'Properties') {
            eventName = parentView;
        }

        return eventName;
    }, [index, parentSubview, parentView]);
}

export function useShouldLogConversion(index, parentView, parentSubview) {
    return useCallback(() => {
        if (index === 'companies') {
            return false;
        }

        if (index === 'properties') {
            if (parentView === 'Properties') {
                if (parentSubview === 'Find Properties' || parentSubview === 'Saved Properties') {
                    return false;
                }
            }

            if (parentView === 'Events') {
                if (parentSubview === 'Saved Properties') {
                    return false;
                }
            }
        }

        if (index === 'saved_searchable_members') {
            if (parentView === 'Events') {
                if (parentSubview === 'My Matches') {
                    return false;
                }
            }

            if (parentView === 'Connections') {
                if (parentSubview === 'My Matches') {
                    return false;
                }
            }
        }

        if (index === 'members') {
            if (parentSubview === 'Members Like Me' || parentSubview === 'Saved Contacts') {
                return false;
            }
        }

        return true;
    }, [index, parentSubview, parentView]);
}

export function useHandleLogConversion(shouldLogConversion, trackEvent, index, getEventName) {
    return useCallback(
        hit => {
            if (shouldLogConversion()) {
                trackEvent({
                    click: {
                        type: 'conversion',
                        index: `${process.env.ALGOLIA_ENV_PREFIX}_${index}`,
                        hit,
                        target: `click_search_result_${index}`,
                        value: getEventName(),
                    },
                });
            }
        },
        [shouldLogConversion, trackEvent, index, getEventName],
    );
}
